// extracted by mini-css-extract-plugin
module.exports = {"root":"DownloadSummaryReport_root__27V-k","disabled":"DownloadSummaryReport_disabled__1bmKT"};